/** URL search-param key that carries a plan to the billing page, which opens that plan's checkout. */
export const PLAN_CHECKOUT_PARAM_KEY = "plan";

/** Billing page that opens the checkout of the plan named in `PLAN_CHECKOUT_PARAM_KEY`. */
export const PLAN_CHECKOUT_BILLING_PATH = "/muggleTestV0/dashboard/billing";
